
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {
  renderAutoCompleteSingleSelect,
} from './../../../../components/reduxFields';
import { Field, reduxForm } from 'redux-form';
import { getMasterData, getRolePermissions, saveRolePermission } from './actions/RolePermissionActions';
import Modules from './containers/modules';
import { SubmitButton } from '../../../../components/buttons';
import _ from 'lodash';
import Alert from 'react-s-alert';

const validate = (values) => {
  const error = {};
  if (!values.Role) {
    error.Role = 'Please enter role ';
  }
};
class RolePermission extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saveRolePermissionsArr: [],
      getRolePermissionsArr: [],
    };
  }

  loadData() {
    this.props.getRolePermissions(this.state.roleId);
  }

  componentWillMount() {
    this.props.getMasterData();
    this.setState({ roleId: this.props.match.params.roleId ? this.props.match.params.roleId : null }, () => {
      this.loadData();
    });
    this.setState({ getRolePermissionsArr: [] });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ saveRolePermissionsArr: []});
    if (nextProps.role_permissions) {
      this.setState({ getRolePermissionsArr: nextProps.role_permissions });
    }
  }
  componentWillUnmount() {
    Alert.closeAll();
  }
  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    this.setState({ roleId: selectedRecord.value }, () => {
      this.loadData();
    });
  }

  // get final data from module
  storePermissions(permissionData) {
    this.setState({ saveRolePermissionsArr: permissionData });
  }

  handleSave = (formProps) => {

    let permissionsArr = this.state.saveRolePermissionsArr.data;
    if (permissionsArr) {
      _.findIndex(permissionsArr.modulePermissions, function(o) {
        o.roleId = formProps.Role;
      });
      _.findIndex(permissionsArr.screenPermissions, function(o) {
        o.roleId = formProps.Role;
      });
      _.findIndex(permissionsArr.actionPermissions, function(o) {
        o.roleId = formProps.Role;
      });
      this.props.saveRolePermission(permissionsArr, this.state.roleId);
    } else {
      Alert.info('Please select role and provide some permissions for the selected role.', {
        position: 'bottom-right',
        effect: 'slide',
        timeout: 50000,
      });
    }
  }

  render() {
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'maintable': true,
      'rolepermission-table': true,

    });

    const { handleSubmit } = this.props;
    return (
      <div>
        <h2 className="page_title">Role Permissions</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form" onSubmit={handleSubmit(this.handleSave.bind(this))}>
              <div className="row">
                <div className="col-sm-6">
                  <div className="row">
                    <div className="col-sm-10 require mt-35">
                      <Field
                        name="Role"
                        label="Select Role"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.masterRoles}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>
                </div>
                {this.state.getRolePermissionsArr && this.state.getRolePermissionsArr.data ?
                  <div className="col-sm-6">
                    <div className="end-flex text-right roleactionbtn">
                      {/* <button className="greyaddremove" type="button" title="Add Permission"><i className="fa fa-check-square greenfont" aria-hidden="true"></i></button>
                    <button className="greyaddremove" type="button" title="Remove Permission"><i className="fa fa-minus-square redfont" aria-hidden="true"></i></button>
                    <button type="button" className="greyaddremove" title="Expand All"><i className="fa fa-plus-square" aria-hidden="true"></i></button>
                    <button type="button" className="greyaddremove" title="Collapse All"><i className="fa fa-minus-square" aria-hidden="true"></i></button>*/}
                    </div>
                  </div>
                  : ''}
              </div>
              <div className="row">
                <div className="col-sm-12 mt-15 table-responsive">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="50%">Modules</th>
                        <th width="50%">Permission</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.getRolePermissionsArr && this.state.getRolePermissionsArr.data ?
                        this.state.getRolePermissionsArr.data.modulePermissions.map((obj, index) =>
                          <Modules
                            key={index}
                            modulePermissionObj={obj}
                            screenPermissions={this.state.getRolePermissionsArr.data.screenPermissions}
                            actionPermissions={this.state.getRolePermissionsArr.data.actionPermissions}
                            rolePermissionsArr={this.state.getRolePermissionsArr}
                            getFinalData={this.storePermissions.bind(this)}
                          />
                        )
                        :
                        <tr>
                          <td colSpan="3">
                            <div className="familydl text-center no-record">Please select role to view permissions.</div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 pt20 btn_rt">
                  {this.state.getRolePermissionsArr && this.state.getRolePermissionsArr.data && this.state.roleId ? <SubmitButton /> : null}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

RolePermission = reduxForm({
  form: 'RolePermission',
  validate,
})(RolePermission);
const mapStateToProps = (state, ownProps) => {
  let userRole = {
    Role: ownProps.match.params.roleId ? parseInt(ownProps.match.params.roleId, 10) : null,
  };
  let masterRoles = [];
  if (state.rolePermissions.master_data.masterRoles) {
    masterRoles = state.rolePermissions.master_data.masterRoles.filter((obj) => obj.userType !== 'ADMIN' && obj.userType !== 'CLIENT');
  }
  // console.log('masterRoles.....', masterRoles)
  return {
    masterRoles: masterRoles,
    masterData: state.rolePermissions.master_data,
    role_permissions: state.rolePermissions.get_role_permissions,
    initialValues: userRole,
  };

};
export default connect(mapStateToProps, { getMasterData, getRolePermissions, saveRolePermission })(RolePermission);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/role-permission/role_permission.js